import actions from './actions';

const {
  setIsShowingSponsorshipsTutorialModal,
  setSponsorshipsTutorialModalAutopairCampaignId,
  setIsOnlyShowingTutorial,
  setIsShowingWaitingScene,
} = actions;

export default {
  setIsShowingSponsorshipsTutorialModal,
  setSponsorshipsTutorialModalAutopairCampaignId,
  setIsOnlyShowingTutorial,
  setIsShowingWaitingScene,
};
